export const actionTypes = {
  SET_LOADING_ON: "[Loading On] Action",
  SET_LOADING_OFF: "[Loading Off] Action",
  SET_TEMP_ADDRESS: "[Set Temp Address] Action",
  SET_ON_BOARDING: "[Set OnBoarding] Action",
  SET_USER_CHANNELS: "[Set User Channels] Action",
  SET_INFO_MODAL: "[Set Info Modal] Action",
  RESET_USER_VARIABLES: "[Reset User Variables] Action",
};

export const actions = {
  loadingOn: () => ({
    type: actionTypes.SET_LOADING_ON,
    payload: true,
  }),
  loadingOff: () => ({
    type: actionTypes.SET_LOADING_OFF,
    payload: false,
  }),
  setTempAddress: (address) => ({
    type: actionTypes.SET_TEMP_ADDRESS,
    payload: address,
  }),
  setOnBoarding: (state) => ({
    type: actionTypes.SET_ON_BOARDING,
    payload: state,
  }),
  setUserChannels: (channelId, channel_toggle) => ({
    type: actionTypes.SET_USER_CHANNELS,
    payload: { channelId, channel_toggle },
  }),
  resetUserVariables: () => ({
    type: actionTypes.RESET_USER_VARIABLES,
    payload: undefined,
  }),
  setInfoModal: (state) => ({
    type: actionTypes.SET_INFO_MODAL,
    payload: { state },
  }),
};
